// extracted by mini-css-extract-plugin
module.exports = {"terms":"terms_terms__QGXJP","terms__modal":"terms_terms__modal__TgF32","terms__bold-text":"terms_terms__bold-text__Cp6LF"};